<template>
  <div class="addControl">
    <!--新增控制范围-->
    <el-dialog
      :title="$t('company.insertControl')"
      :visible.sync="dialogAdd"
      :close-on-click-modal="false"
      width="580px"
    >
      <el-tabs type="border-card">
        <el-tab-pane :label="$t('company.controlRangeInfo')">
          <el-form
            label-width="110px"
            ref="controlDialog"
            :label-position="'right'"
            :rules="rules"
            :model="addInfo"
          >
            <el-form-item :label="$t('company.detail.controlName')" prop="controlAreaName">
              <el-input
                v-model="addInfo.controlAreaName"
                class="inputWidth"
                clearable
                :maxlength="64"
                :placeholder="$t('company.controlAreaNamePlaceholder')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('company.detail.controlAreaCode')" prop="controlAreaCode">
              <el-input
                v-model="addInfo.controlAreaCode"
                class="inputWidth"
                clearable
                :maxlength="64"
                :placeholder="$t('company.controlAreaCodePlaceholder')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('company.detail.companyIndex')" prop="sortOrder">
              <el-input-number
                v-model="addInfo.sortOrder"
                controls-position="right"
                class="inputWidth"
                :min="0"
                :max="999"
              ></el-input-number>
            </el-form-item>
          </el-form>
          <div class="department-content">{{ this.$t('company.controlRangeTitle') }}</div>
          <!--新增/删除按钮-->
          <vxe-toolbar>
            <template v-slot:buttons>
              <vxe-button
                type="primary"
                icon="el-icon-plus"
                class="vxe-btn-primary"
                @click="insertEvent()"
                >{{ $t('xTable.insert') }}</vxe-button
              >
              <vxe-button
                type="primary"
                icon="el-icon-delete"
                class="vxe-btn-delete"
                @click="deleteEvent()"
                >{{ $t('xTable.delete') }}</vxe-button
              >
            </template>
          </vxe-toolbar>
          <!---可编辑表格-->
          <vxe-table
            border
            size="mini"
            show-overflow
            show-header-overflow
            ref="xTable"
            class="edit-table"
            :height="80"
            :max-height="180"
            :data="tableData"
            :edit-rules="validRules"
            :edit-config="{ trigger: 'click', mode: 'row', showStatus: true }"
          >
            <vxe-table-column type="checkbox" width="50"></vxe-table-column>
            <vxe-table-column type="seq" width="60" :title="$t('table.index')"></vxe-table-column>
            <vxe-table-column
              field="controlAreaDepartmentNo"
              :title="$t('company.table.departmentName')"
              :edit-render="{ type: 'default' }"
            >
              <template v-slot:edit="scope">
                <treeselect
                  :options="options"
                  v-model="scope.row.controlAreaDepartmentNo"
                  :defaultExpandLevel="Infinity"
                  openDirection="auto"
                  :clearable="false"
                  :maxHeight="200"
                  :zIndex="2999"
                  :flat="true"
                  :append-to-body="true"
                  @select="(val) => selectNode(val, scope)"
                  :placeholder="$t('company.treeselect.searchIndex')"
                  :noResultsText="$t('company.treeselect.noData')"
                  :searchPromptText="$t('company.treeselect.searchIndex')"
                />
              </template>
              <template v-slot="{ row }">{{ row.controlDepartmentName }}</template>
            </vxe-table-column>
          </vxe-table>
        </el-tab-pane>
        <el-tab-pane :label="$t('company.system')"></el-tab-pane>
      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loading" @click="addSure()">{{
          $t('dialog.confirm')
        }}</el-button>
        <el-button @click="dialogAdd = false">{{ $t('dialog.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/masterData/company.js';
  import { isEqual } from '@/common/js/util';

  export default {
    name: 'addControl',
    data() {
      return {
        dialogAdd: false,
        loading: false,
        addInfo: {
          controlAreaName: null,
          controlAreaCode: null,
          sortOrder: 0,
        },
        tableData: [],
        options: [],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      rules() {
        // 校验特殊字符
        var specialValidate = (rule, value, callback) => {
          var reg = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/;
          if (value != null && value.match(reg)) {
            callback(new Error(this.$t('menu.emoticons')));
          } else {
            callback();
          }
        };

        // 校验控制范围代码格式
        // var codeValidate = (rule, value, callback) => {
        //   let str = value.slice(0, 2);
        //   if (str != '7H') {
        //     callback(new Error(this.$t('company.controlAreaCodeError')));
        //   }
        //   var reg = /^[0-9]*$/;
        //   str = value.slice(2);
        //   var numRe = new RegExp(reg);
        //   if (!numRe.test(str)) {
        //     callback(new Error(this.$t('company.controlAreaCodeError')));
        //   } else {
        //     callback();
        //   }
        // };
        return {
          controlAreaName: [
            {
              required: true,
              message: this.$t('company.controlAreaNameNotEmpty'),
              trigger: 'blur',
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
          ],
          /* controlAreaCode: [
          {
            required: true,
            message: this.$t("company.controlAreaCodeNotEmpty"),
            trigger: "blur"
          },
          { validator: codeValidate, trigger: ["blur", "change"] }
        ] */
        };
      },
      validRules() {
        return {
          controlAreaDepartmentNo: [
            { required: true, message: this.$t('company.departmentNameNotEmpty') },
          ],
        };
      },
    },
    methods: {
      openDialog(flag) {
        if (this.$refs['controlDialog']) {
          this.$refs['controlDialog'].resetFields();
        }
        this.tableData = [];
        // for (let i = 0; i < 5; i++) {
        //   this.tableData.push({
        //     controlAreaDepartmentNo: null,
        //     controlDepartmentName: null,
        //     controlAreaCompanyNo: null,
        //     controlAreaTenantNo: null
        //   });
        // }
        //初始化公司-部门树
        this.initDepartment();
        this.loading = false;
        this.dialogAdd = flag;
      },
      initDepartment() {
        const query = {
          tenantCode: this.userInfo.userInfo.tenantCode,
          adminFlag: this.userInfo.userInfo.adminFlag,
        };
        this.$axios.post(API.LIST_COMPANY_API, query).then((res) => {
          if (0 == res.data.code) {
            this.options = res.data.data;
            this.getSelectedNode(this.options, this.options);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //删掉没有子节点的children
      getSelectedNode(nodeData) {
        nodeData.forEach((item) => {
          if ('children' in item && item.children.length === 0) {
            delete item.children;
          } else if ('children' in item && item.children.length) {
            this.getSelectedNode(item.children, item);
          }
        });
      },
      //新增一行
      insertEvent() {
        // const tableList = this.$refs.xTable.getTableData().fullData;
        this.$refs.xTable.validate().then(() => {
          const record = {
            controlAreaDepartmentNo: null,
            controlDepartmentName: null,
            controlAreaCompanyNo: null,
            controlAreaTenantNo: null,
          };
          this.$refs.xTable.insert(record).then(({ row }) => this.$refs.xTable.setActiveRow(row));
        });
      },
      //删除一行
      deleteEvent() {
        let selectRecords = this.$refs.xTable.getCheckboxRecords();
        if (selectRecords.length) {
          this.$refs.xTable.removeSelecteds();
        } else {
          this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
        }
      },
      //选中节点
      selectNode(node, scope) {
        this.$axios.get(API.GET_PARENT_UNIT_API + '/' + node.id).then((res) => {
          if (0 == res.data.code) {
            scope.row.controlDepartmentName = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
        scope.row.controlAreaCompanyNo = node.attributes.belongCompanyCode;
        scope.row.controlAreaTenantNo = node.attributes.belongTenantCode;
        this.$refs.xTable.updateStatus(scope);
      },
      //保存
      addSure() {
        // let xTableValidFlag = true;
        let status = false;
        //1.校验表格
        this.$refs.xTable.validate().then(() => {
          const tableList = this.$refs.xTable.getTableData().fullData;
          //2.判断是否有重复的数据
          if (tableList.length > 1) {
            let start = 1;
            for (let n = 0; n < tableList.length; n++) {
              if (status) {
                break;
              }
              for (start; start < tableList.length; start++) {
                if (n != start) {
                  status = isEqual(tableList[n], tableList[start], 'controlAreaDepartmentNo');
                  if (status) {
                    break;
                  }
                }
              }
              start = n;
            }
          }
          if (status) {
            this.$message({
              showClose: true,
              message: this.$t('company.departmentSameData'),
              type: 'error',
            });
            return;
          }
          this.$refs['controlDialog'].validate((valid) => {
            if (valid && !this.loading) {
              this.loading = true;
              this.addInfo.tenantCode = this.userInfo.userInfo.tenantCode;
              this.addInfo.companyCode = this.userInfo.userInfo.companyCode;
              this.addInfo.companyName = this.userInfo.userInfo.companyName;
              this.addInfo.departmentCode = this.userInfo.userInfo.departmentCode;
              this.addInfo.departmentName = this.userInfo.userInfo.departmentName;
              this.addInfo.belongTenantCode = this.userInfo.userInfo.tenantCode;
              this.addInfo.controlAreaDepartmentStr =
                tableList.length == 0 ? null : JSON.stringify(tableList);
              this.$axios.post(API.ADD_SCONTROLAREA_API, this.addInfo).then((res) => {
                this.loading = false;
                if (0 != res.data.code) {
                  this.$alert(res.data.msg);
                } else {
                  this.dialogAdd = false;
                  this.$emit('getData');
                  this.$message({
                    showClose: true,
                    message: res.data.msg || this.$t('message.success'),
                    type: 'success',
                  });
                }
              });
            } else {
              return false;
            }
          });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .department-content {
    font-size: 14px;
    font-weight: 500;
    color: rgba(40, 55, 79, 1);
  }
</style>
